import React, { useState } from 'react';
import ConfirmModal from '../ConfirmModal';
import './AccountSidebar.css';

const DEFAULT_ITEMS = [
  { id: 'account-info', label: 'Información de cuenta' },
  { id: 'order-history', label: 'Historial de pedidos' },
  { id: 'returns', label: 'Devoluciones' },
  { id: 'communications', label: 'Comunicaciones' },
];

const AccountSidebar = ({ activeSection, setActiveSection, onLogout, menuItems }) => {
  const items = menuItems && menuItems.length ? menuItems : DEFAULT_ITEMS;

  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const handleLogout = () => setShowLogoutConfirm(true);
  const confirmLogout = () => {
    setShowLogoutConfirm(false);
    if (onLogout) onLogout();
  };
  const cancelLogout = () => setShowLogoutConfirm(false);

  return (
    <>
      <aside className="account-sidebar">
        <nav className="account-sidebar__nav">
          {items.map((item) => (
            <button
              key={item.id}
              className={`account-sidebar__link ${
                activeSection === item.id ? 'account-sidebar__link--active' : ''
              } ${item.highlight ? 'account-sidebar__link--highlight' : ''}`}
              onClick={() => setActiveSection(item.id)}
            >
              {item.label}
            </button>
          ))}
          <button
            className="account-sidebar__link"
            onClick={handleLogout}
          >
            Cerrar sesión
          </button>
        </nav>
      </aside>
      <ConfirmModal
        isOpen={showLogoutConfirm}
        message="¿Estás seguro que deseas cerrar sesión?"
        confirmText="Cerrar sesión"
        onConfirm={confirmLogout}
        onCancel={cancelLogout}
      />
    </>
  );
};

export default AccountSidebar;
